import { render, staticRenderFns } from "./warehouseMaterialMarkTip.vue?vue&type=template&id=36234c4a&scoped=true&"
import script from "./warehouseMaterialMarkTip.vue?vue&type=script&lang=js&"
export * from "./warehouseMaterialMarkTip.vue?vue&type=script&lang=js&"
import style0 from "./warehouseMaterialMarkTip.vue?vue&type=style&index=0&id=36234c4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36234c4a",
  null
  
)

export default component.exports